import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const setSelectEditOrPublishButtonStateReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<'editor' | 'publish'>) => {
    state.selectEditOrPublishButtonState = action.payload;
  });
};

export default setSelectEditOrPublishButtonStateReducer;
